export default function HWY_Article() {
    var page = 2; // Trang bắt đầu tải (trang 1 đã được tải sẵn)
    var post_per_page = 7; // Số lượng bài đăng tải mỗi lần
    var catID = null;
    var total = parseInt(jQuery("#blog-posts .total").data("total"));
    this.init = () => {
        loadMore();
        filterArticle();
    };
    const loadMore = () => {
        jQuery("#load-more-btn").on("click", function () {
            getList();
        });
    };
    const filterArticle = () => {
        jQuery(".filter-by-category a").click(function () {
            jQuery("#blog-posts .inner").empty();
            jQuery("#blog-posts .load-more-wrapper").hide();
            catID = jQuery(this).data("id");
            page = 1;
            getTotal();
        });
    };
    const getList = () => {
        jQuery(document).ready(function ($) {
            var data = {
                action: "load_more_posts",
                page: page,
                post_per_page: post_per_page,
                cat_id: catID,
            };

            $.ajax({
                url: theme_object.ajax_url, // ajaxurl được định nghĩa sẵn trong WordPress
                type: "POST",
                data: data,
                success: function (response) {
                    $("#blog-posts .load-more-wrapper").show();
                    if (response != 0) {
                        $("#blog-posts .inner").append(response);
                        $(".load-more-wrapper .pagination .current").text(
                            $("#blog-posts .inner .post-item").length
                        );
                        if ($("#blog-posts .inner .post-item").length >= total) {
                            $("#load-more-btn").hide();
                        } else {
                            $("#load-more-btn").show();
                        }
                        page++;
                    } else {
                        $(".load-more-wrapper .pagination .current").text(
                            $("#blog-posts .inner .post-item").length
                        );
                        $("#load-more-btn").hide();
                    }
                },
            });
        });
    };
    const getTotal = () => {
        jQuery(document).ready(function ($) {
            var data = {
                action: "get_filtered_post_count",
                cat_id: catID,
            };

            $.ajax({
                url: theme_object.ajax_url,
                type: "GET",
                data: data,
                success: function (response) {
                    $("#blog-posts .load-more-wrapper .total").attr(
                        "data-total",
                        response
                    );
                    $("#blog-posts .load-more-wrapper .total").text(response);
                    total = response;
                    getList();
                },
            });
        });
    };
}
